const relatorInfo = (type: string) => {
  let data = {
    relatorBirthDate: "",
    relatorEmail: "",
    relatorEngName: "",
    relatorHolder: "01",
    relatorIdNo: "",
    relatorMobileTelNo: "",
    relatorName: "",
    relatorPlanType: "",
    relatorPremium: "",
    relatorSeq: "1",
    relatorSexCode: "",
    relatorType: "02"
  };
  if (type === "companion") {
    data.relatorHolder = "08";
    data.relatorSeq = "";
    data.relatorType = "03";
  }
  return data;
};

const formData = {
  policyEndDate: "",
  policyEndHour: "",
  policyStartDate: "",
  policyStartHour: "",
  travelAim: "01",
  travelPlace: "",
  relatorInfo: [relatorInfo("representative")],
  sponsorMngNo: "",
  sponsorCode: "myrealtrip"
};
const userData = [
  {
    relatorBirthDate: "",
    identificationFront: "",
    identificationBack: "",
    sex: "M",
    userTypePrice: [
      { type: "", price: "" },
      { type: "", price: "" },
      { type: "", price: "" }
    ],
    selectedPlanType: ""
  }
];
const viewData = {
  totalPrice: "",
  travelContinent: "",
  agreeAll: false,
  agreePartner: false,
  startDate: undefined,
  endDate: undefined,
  alertModal: {
    visible: false,
    hasCancel: false,
    title: "",
    content: "",
    focusRef: "",
    index: 999
  },
  travelCountry: {
    code: "",
    continentCode: "",
    forbiddenYn: "",
    name: "",
    partialForbiddenRegion: null,
    partialForbiddenYn: "",
    img: "img_default.jpg"
  }
};

const validationTravelValue = {
  form: {
    travelContinent: {
      name: "여행지역",
      errorMessage: "여행지역을 선택해주세요.",
      validation: {
        required: true
      },
      valid: false
    },
    travelPlace: {
      name: "여행국가",
      errorMessage: "여행국가를 선택해주세요.",
      validation: {
        required: true
      },
      valid: false
    },
    policyStartDate: {
      name: "출국일자",
      errorMessage: "출국일자를 선택해주세요.",
      validation: {
        required: true
      },
      valid: false
    },
    policyStartHour: {
      name: "출국시간",
      errorMessage: "출국시간을 선택해주세요.",
      validation: {
        required: true
      },
      valid: false
    },
    policyEndDate: {
      name: "귀국일자",
      errorMessage: "귀국일자를 선택해주세요.",
      validation: {
        required: true
      },
      valid: false
    },
    policyEndHour: {
      name: "귀국시간",
      errorMessage: "귀국시간을 선택해주세요.",
      validation: {
        required: true
      },
      valid: false
    }
  },
  formIsValid: false
};
const validationUserValue = {
  form: {
    relatorName: {
      name: "국문성명",
      errorMessage: "국문성명을 확인해주세요",
      validation: {
        required: true,
        isKorName: true,
        minLength: 2,
        maxLength: 20
      },
      valid: false
    },
    relatorEngName: {
      name: "영문성명",
      errorMessage: "영문성명을 입력해주세요.",
      validation: {
        required: true,
        isEngName: true,
        minLength: 2
      },
      valid: false
    },
    identificationFront: {
      name: "주민번호 앞자리",
      errorMessage: "주민번호 앞자리를 입력해주세요.",
      validation: {
        required: true,
        minLength: 6,
        maxLength: 6,
        isnumeric: true
      },
      valid: false
    },
    identificationBack: {
      name: "주민번호 뒷자리",
      errorMessage: "주민번호 뒷자리를 입력해주세요.",
      validation: {
        required: true,
        minLength: 7,
        maxLength: 7,
        isnumeric: true
      },
      valid: false
    },
    relatorMobileTelNo: {
      name: "휴대전화번호",
      errorMessage: "휴대전화번호를 형식에 맞게 입력해주세요.(예 01023456789)",
      validation: {
        required: true,
        isMobile: true,
        minLength: 10,
        maxLength: 11
      },
      valid: false
    },
    relatorEmail: {
      name: "이메일",
      errorMessage: "이메일을 형식에 맞게 입력해주세요.(예 id@naver.com)",
      validation: {
        required: true,
        isEmail: true,
        minLength: 5,
        maxLength: 320
      },
      valid: false
    }
  },
  formIsValid: false
};

const paymentData = {
  impPaymentInitRequest: {
    pg: "nice",
    pay_method: "card",
    merchant_uid: "",
    buyer_name: "",
    buyer_email: "",
    buyer_tel: "",
    name: "Chubb 해외여행보험",
    amount: 0,
    niceMobileV2: true,
    m_redirect_url: `${process.env.REACT_APP_BASE_URL}/payment/complete`,
    app_scheme: ""
  },
  insTransactionNo: "",
  productId: "4"
};

export const travelContainerDefaultState = {
  continentList: [],
  countryList: [],
  forbiddenList: [],
  formData: formData,
  userData: userData,
  viewData: viewData,
  validData: {
    validationTravelValue: validationTravelValue,
    validationUserValue: validationUserValue,
    validationPartnerValue: [],
    validationIdentificationValue: {
      formIsValid: false
    }
  },
  paymentData: paymentData,
  clickedNext: false
};

export const simpleCheckContainerDefaultState = {
  ...travelContainerDefaultState,
  simpleCheckStep: "step1"
};

export const ParterDefaultState = {
  ...relatorInfo("companion")
};

export const ParterUserDefaultState = {
  ...userData[0]
};

export const SubscriptionDetailValue = {
  insuranceName: "",
  policyStartDate: "",
  policyStartDateTime: "",
  policyEndDate: "",
  policyEndDateTime: "",
  insuranceDate: "",
  insuranceNo: "",
  totalAmount: "",
  insuredInfo: {
    name: "",
    telMobile: "",
    email: ""
  },
  travelInfo: {
    country: "",
    companionInfoList: [
      {
        name: "",
        nameEn: "",
        birth: "",
        plan: "",
        amount: "",
        planCode: ""
      }
    ]
  }
};

export const IntroducePopupValue = {
  notice: {
    isVisible: false,
    title: "일시 가입 중단 안내",
    desc: "2019년 10월 14일 16:00부터 16:30까지 서비스 점검이 있을 예정입니다."
  },
  check: {
    isVisible: false,
    title: "일시 가입 중단 안내",
    desc: "2019년 10월 14일 16:00부터 16:30까지 서비스 점검이 있을 예정입니다."
  }
};
